<template>
  <b-row class="pr-3">
    <b-col cols="12" class="">
      <PageTitle title="Grade de Produto" />
    </b-col>
    
    <b-col>
      <h6>Aqui será possivél criar/editar as grades dos produtos</h6>
    </b-col>

    <b-col cols="12" class="mt-4">
      <b-button 
        variant="success" 
        @click="$refs.attributeModal.toggleOpen({
          shopkeeperId: dadosUsuario.id,
        })"
      >
        <i class="fas fa-plus mr-1"></i>
        Adicionar Atributo
      </b-button>
      
      <b-button 
        class="ml-4"
        variant="primary"
        @click="$refs.valueAttributeModal.toggleOpen({
          dataAttribute: []
        })"
      >
        <i class="fas fa-code-branch mr-1"></i>
        Adicionar Atributo Filho
      </b-button>

      <b-button 
        class="ml-4"
        variant="warning"
        @click="$refs.selectedProductsAttributeModal.toggleOpen({
          shopkeeperId: dadosUsuario.id,
        })"
      >
        <i class="fas fa-eye mr-1"></i>
        Ver Produtos Relacionados
      </b-button>
    </b-col>

    <b-col cols="12" class="mt-4">
      <b-table
        striped
        outlined
        hover
        responsive
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
        empty-text="Nenhum produto encontrado"
      >
        <template #cell(attribute)="data">
          <b-button 
            @click="$refs.attributeModal.toggleOpen({
              shopkeeperId: dadosUsuario.id,
              id: data.item.attribute_id,
              name: data.item.attribute,
            })"
            variant="success"
            data-toggle="tooltip" 
            data-placement="top" 
            title="Editar Atributo Pai"
            size="sm"
            class="mr-2"
          >
            <i class="fas fa-edit "></i>
          </b-button>
          <b-button 
            @click="$refs.deleteAttributeModal.toggleOpen({
              dataAttribute: data.item,
              shopkeeperId: dadosUsuario.id,
              isDadAttribute: true,
            })"
            variant="danger"
            data-toggle="tooltip" 
            data-placement="top" 
            title="Apagar Atributo Pai"
            class="mr-2"
            size="sm"
          >
            <i class="fas fa-trash"></i>
          </b-button>
          - {{ data.item.attribute }} 
        </template>

        <template #cell(values_attribute)="data">
          <b-button 
            @click="$refs.valueAttributeModal.toggleOpen({
              dataAttribute: data.item,
            })"
            variant="primary"
            data-toggle="tooltip" 
            data-placement="top" 
            title="Editar Atributo Filho"
            class="mr-2"
            size="sm"
            :disabled="!data.item.values_attribute"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button 
            @click="$refs.deleteAttributeModal.toggleOpen({
              dataAttribute: data.item,
              shopkeeperId: dadosUsuario.id,
              isDadAttribute: false,
            })"
            variant="danger"
            data-toggle="tooltip" 
            data-placement="top" 
            title="Apagar Atributo Filho"
            class="mr-2"
            size="sm"
            :disabled="!data.item.values_attribute"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        - {{ data.item.values_attribute }}
        </template>
      </b-table>
    </b-col>

    <AttributeModal 
      ref="attributeModal"
      @getAttribute="getAttribute()"
    />
    <ValueAttributeModal 
      ref="valueAttributeModal"
      :options="optionsAttribute"
      @getAttribute="getAttribute()"
    />

    <DeleteAttributeModal 
      ref="deleteAttributeModal"
      @getAttribute="getAttribute()"
    />
    <SelectedProductsAttributeModal
      ref="selectedProductsAttributeModal"
    />

  </b-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import PageTitle from '@/components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import AttributeModal from '@/components/AttributeModal.vue';
import ValueAttributeModal from '@/components/ValueAttributeModal.vue';
import DeleteAttributeModal from '@/components/DeleteAttributeModal.vue';
import SelectedProductsAttributeModal from '@/components/SelectedProductsAttributeModal.vue';

export default {
  name: 'ShopkeeperVariationProduct',
  mixins: [makeToast],
  components: { 
    PageTitle,
    AttributeModal,
    ValueAttributeModal,
    DeleteAttributeModal,
    SelectedProductsAttributeModal
  },

data() {
  return {
    loading: false,
    optionsAttribute: [],
    table: {
      headers: [
        {
          key: 'index',
          thClass: 'd-none',
          tdClass: 'd-none',
        },
        {
          key: 'attribute',
          label: 'Atributo Pai',
          sortable: true,
        },
        {
          key: 'values_attribute',
          label: 'Atributo Filho',
          sortable: true,
        },
      ],
      records: [],
    },
  }
},

computed: {
  ...mapState(['dadosUsuario']),
},

mounted() {
  this.getAttribute();
},

methods: {
  getAttribute() {
    this.table.records = [];
    this.optionsAttribute = [];

    this.$store.dispatch('startLoader');
    this.$store.dispatch('shopkeeper/getAttributeProduct', this.dadosUsuario.id)
      .then((response) => {
        const result = response.data.data.data;

        this.optionsAttribute.push({
          value: 0,
          text: 'Selecione o Atributo',
        });

        result.forEach((item) => {
          this.optionsAttribute.push({
            value: item.id,
            text: item.name,
          });

          if (!item.values_attribute || item.values_attribute.length === 0) {
            this.table.records.push({
              valueAttributeId: item.id,
              attribute: item.name,
              values_attribute: '',
              attribute_id: item.id,
            });
          } else {
            item.values_attribute.forEach((childAttr) => {
              this.table.records.push({
                valueAttributeId: childAttr.id,
                attribute: item.name,
                values_attribute: childAttr.value,
                attribute_id: item.id,
              });
            });
          }
        });
      })
      .catch((error) => {
        this.makeToast(
          'Erro',
          `Houve um erro ao buscar os dados`,
        );
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
  },
}
}
</script>
